import React, { useState, useRef, useEffect } from "react";
import data from "../../femcare-content.json";
import { useNavigate } from "react-router-dom";
import { DoctorCard } from "../Appointments/BookAppointment";
import { orgId_const } from "../../config";

const { meetDoctors } = data.sections;

const MeetDoctors = () => {
  const { id, heading, tagline, items, cta } = meetDoctors;

  const [visibleCount, setVisibleCount] = useState(4);
  const [startIndex, setStartIndex] = useState(0);
  const trackRef = useRef(null);
  const CLINIC_ID = `${orgId_const}`;
  const BASE_URL = `https://api.avexa.net/clinic-onboarding`;
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // ✅ Responsive visible count
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width < 640) {
        setVisibleCount(1); // mobile
      } else if (width < 1024) {
        setVisibleCount(2); // tablet
      } else {
        setVisibleCount(4); // desktop
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    setLoading(true);
    const fetchProviders = async () => {
      try {
        // Step 1: fetch providers list
        const res = await fetch(`${BASE_URL}/clinics/${CLINIC_ID}/providers`);
        if (!res.ok) throw new Error('Failed to fetch providers');
        const data = await res.json();
        const providerList = data.providers?.slice(0,4) ?? [];

        // Step 2: for each provider, fetch their profile using providerId
        const enriched = await Promise.all(
          providerList.map(async (provider) => {
            try {
              const profileRes = await fetch(
                `${BASE_URL}/clinics/${CLINIC_ID}/providers/${provider.providerId}/onboarding/profile`
              );
              if (!profileRes.ok) return provider; // fallback to base data if profile fails
              const profile = await profileRes.json();
              return { ...provider, ...profile }; // merge profile into provider
            } catch {
              return provider; // fallback silently
            }
          })
        );

        setProviders(enriched);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProviders();
  }, []);


  // const hasMore = items.length > visibleCount;
  // const maxStart = items.length - visibleCount;

  // const canPrev = startIndex > 0;
  // const canNext = startIndex < maxStart;

  const handlePrev = () => setStartIndex((i) => Math.max(0, i - 1));
  const handleNext = () =>
    setStartIndex((i) => Math.min(maxStart, i + 1));

  // const visibleItems = hasMore
  //   ? items.slice(startIndex, startIndex + visibleCount)
  //   : items;
  const hasMore = providers.length > visibleCount;
  const maxStart = providers.length - visibleCount;
  const canPrev = startIndex > 0;
  const canNext = startIndex < maxStart;
  const visibleItems = hasMore
    ? providers.slice(startIndex, startIndex + visibleCount)
    : providers;
console.log(visibleItems,"this is tevisibleItems")

  return (
    <section id={id} className="w-full bg-white py-4 md:py-8 "
    style={{
        boxShadow: "rgba(220, 80, 130, 0.09) 0px -11px 25px",

    }}
    >
      <div className="container mx-auto px-4 md:px-8">
        {/* Heading */}
        <h2
          className="text-center ava-heading-lg mb-8 md:mb-10"
          style={{
            // color: "var(--primary-color)",
            // fontSize: "clamp(1.4rem, 2.8vw, 2rem)",
          }}
        >
          {heading}
        </h2>

        <div className="relative">
          {/* ✅ Prev Arrow (now visible on all devices if needed) */}
          {hasMore && (
            <button
              onClick={handlePrev}
              disabled={!canPrev}
              className="flex absolute -left-3 md:-left-6 top-1/2 -translate-y-1/2 z-10 w-9 h-9 shadow-md items-center justify-center rounded-full bg-white border"
              style={{
                borderColor: canPrev
                  ? "var(--primary-color)"
                  : "var(--gray-300)",
                opacity: canPrev ? 1 : 0.4,
              }}
            >
              <img
                src="/images/left-arrow.svg"
                alt="Previous"
                className="w-9 h-9"
              />
            </button>
          )}

          {/* ✅ Grid updated dynamically */}
          <div
            ref={trackRef}
            className={`grid ava-card-gap`}
            style={{
              gridTemplateColumns: `repeat(${visibleCount}, minmax(0, 1fr))`,
            }}
          >
            {visibleItems.map((doc, index) => (
              <DoctorCard
                // key={doc.id}
                key={doc.providerId}
                doc={doc}
                // doctor={{
                //   id: doc.providerId,
                //   name: doc.fullName,
                //   image: doc.image ?? null,
                //   ratings: doc.rating ?? 5,
                //   qualification: doc.qualification,
                //   designation: doc.designation,
                //   experience: `${doc.experienceYears} yrs`,
                //   specialties: doc.specializations ?? [],
                // }}
                index={index}

              />
            ))}
          </div>

          {/* ✅ Next Arrow */}
          {hasMore && (
            <button
              onClick={handleNext}
              disabled={!canNext}
              className="flex absolute -right-3 md:-right-6 top-1/2 -translate-y-1/2 z-10 w-9 h-9 shadow-md items-center justify-center rounded-full bg-white border"
              style={{
                borderColor: canNext
                  ? "var(--primary-color)"
                  : "var(--gray-300)",
                opacity: canNext ? 1 : 0.4,
              }}
            >
              <img
                src="/images/right-arrow.svg"
                alt="Next"
                className="w-9 h-9"
              />
            </button>
          )}
        </div>
      </div>

      {/* CTA */}
      {/* {cta && (
        <div className="flex justify-center mt-2 md:mt-4">
          <a
            href={cta.href}
            className="btn-primary"
          >
            {cta.label}
          </a>
        </div>
      )} */}
    </section>
  );
};

/* Doctor Card (unchanged) */

// const DoctorCard = ({ doctor }) => {
//   const navigate = useNavigate();

//   const StarIcon = () => (
//     <svg width="14" height="14" viewBox="0 0 24 24" fill="#F5A623">
//       <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
//     </svg>
//   );

//   const VerifiedIcon = () => (
//     <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
//       <circle cx="12" cy="12" r="10" fill="#0D9488" opacity="0.15" />
//       <circle cx="12" cy="12" r="10" stroke="#0D9488" strokeWidth="2" />
//       <path d="M9 12l2 2 4-4" stroke="#0D9488" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//   );

//   const BriefcaseIcon = () => (
//     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--secondary-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <rect x="2" y="7" width="20" height="14" rx="2" />
//       <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
//     </svg>
//   );

//   const CalendarIcon = () => (
//     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0D9488" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <rect x="3" y="4" width="18" height="18" rx="2" />
//       <path d="M16 2v4M8 2v4M3 10h18" />
//     </svg>
//   );

//   return (
//     <div style={{
//       borderRadius: "20px",
//       overflow: "hidden",
//       background: "#fff",
//       border: "1px solid #F0EEF8",
//       boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
//       display: "flex",
//       flexDirection: "column",
//     }}>

//       {/* ── Image section ── */}
//       <div style={{ position: "relative", width: "100%", paddingTop: "80%" }}>
//         <img
//           src={doctor.image}
//           alt={doctor.name}
//           draggable={false}
//           style={{
//             position: "absolute",
//             inset: 0,
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             objectPosition: "top center",
//           }}
//         />

//         {/* Rating badge */}
//         <div style={{
//           position: "absolute",
//           top: "12px",
//           left: "12px",
//           background: "#fff",
//           borderRadius: "10px",
//           padding: "5px 10px",
//           display: "flex",
//           alignItems: "center",
//           gap: "5px",
//           boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
//         }}>
//           <StarIcon />
//           <span style={{ fontSize: "13px", fontWeight: 700, color: "#1E1030" }}>
//             {doctor.ratings}
//           </span>
//         </div>

//         {/* Wave SVG — sits at the bottom of the image, overlapping */}
//         {/* <div style={{
//           position: "absolute",
//           bottom: -2,
//           left: 0,
//           right: 0,
//           lineHeight: 0,
//         }}>
//           <svg
//             viewBox="0 0 400 40"
//             xmlns="http://www.w3.org/2000/svg"
//             preserveAspectRatio="none"
//             style={{ width: "100%", height: "40px", display: "block" }}
//           >
//             <path
//               d="M0,20 C60,40 120,0 200,20 C280,40 340,0 400,20 L400,40 L0,40 Z"
//               fill="#ffffff"
//             />
//           </svg>
//         </div> */}
//       </div>

//       {/* ── Info section ── */}
//       <div style={{ padding: "0 16px 0", marginTop: "-2px", background: "#fff", marginTop: "15px" }}>

//         {/* Name + Verified */}
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px", marginBottom: "4px" }}>
//           <span style={{ fontSize: "15px", fontWeight: 700, color: "#1E1030" }}>
//             {doctor.name}
//           </span>
//           <div style={{ display: "flex", alignItems: "center", gap: "4px", flexShrink: 0 }}>
//             <VerifiedIcon />
//             <span style={{ fontSize: "10px", fontWeight: 600, color: "#0D9488" }}>
//               Verified Specialist
//             </span>
//           </div>
//         </div>

//         {/* Qualification — pink/magenta */}
//         <p style={{ fontSize: "12px", color: "var(--secondary-color)", fontWeight: 600, margin: "0 0 8px" }}>
//           {doctor.qualification}, {doctor.designation}
//         </p>

//         {/* Experience */}
//         <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "12px" }}>
//           <BriefcaseIcon />
//           <span className="ava-text-caption">
//             {doctor.experience} Experience
//           </span>
//         </div>

//         {/* Specialty tags */}
//         {doctor.specialties?.length > 0 && (
//           <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "14px" }}>
//             {doctor.specialties.map((tag, i) => (
//               <span key={i} style={{
//                 // fontSize: "11px",
//                 // fontWeight: 500,
//                 // color: "var(--secondary-color)",
//                 // background: "#FCF0F7",
//                 border: "1px solid var(--ava-color-secondary-300)",
//                 borderRadius: "20px",
//                 padding: "3px 10px",
//               }}
//                 className="ava-text-2xs ava-card-bg"
//               >
//                 {tag}
//               </span>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Divider */}
//       <div style={{ height: "1px", background: "#F0EEF8", margin: "0 16px" }} />

//       {/* ── Availability + CTA ── */}
//       <div style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         padding: "10px 16px 14px",
//         gap: "8px",
//       }}>
//         <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
//           <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//             <CalendarIcon />
//             <span style={{ fontSize: "12px", fontWeight: 700, color: "#0D9488" }}>
//               {doctor.availabilityLabel ?? "Available Today"}
//             </span>
//           </div>
//           {doctor.nextSlot && (
//             <span style={{ fontSize: "11px", color: "#888", marginLeft: "19px" }}>
//               Next: {doctor.nextSlot}
//             </span>
//           )}
//         </div>

//         <button style={{
//           background: "none",
//           border: "none",
//           cursor: "pointer",
//           display: "flex",
//           alignItems: "center",
//           gap: "4px",
//           fontSize: "12px",
//           fontWeight: 700,
//           color: "#0D9488",
//           padding: 0,
//           whiteSpace: "nowrap",
//         }}
//           onClick={() => navigate(
//             `/book-appointment?openModal=true&doctorId=${doctor.id}`
//           )}
//         >
//           Book an Appointment
//           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0D9488" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//             <path d="M5 12h14M12 5l7 7-7 7" />
//           </svg>
//         </button>
//       </div>

//     </div>
//   );
// };
export default MeetDoctors;



